import { encode } from "base-64";
import { useContext, useState, useEffect } from "react";
import { config } from "src/configs/config";
import { AuthContext } from "src/context/AuthContext";
import { types } from "src/context/types";
import Swal from "sweetalert2";
import { loginFetch, getParams } from "../general_helpers/loginFetch";
import Box from "@mui/material/Box";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Grid } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import KeyIcon from "@mui/icons-material/Key";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import { Container } from "@mui/material";
import Video_Login from "src/assets/video/D-Box.mp4"; // url del video personalizable
import FilledInput from "@mui/material/OutlinedInput";
import { Login as LoginIcon } from "@mui/icons-material";
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponentRC";
import { RecuperarContrasenia } from "src/general_components/RecuperarContrasenia";
import { parametros_proyecto, id_proyecto } from "src/configs/config";
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser,
} from "amazon-cognito-identity-js";
import { ConfirmationModal } from "./ConfirmationModal";
import { useTheme } from "@mui/material/styles";
import Cookies from "js-cookie";
import LoadingOverlay from "src/general_components/LoadingOverlay";
import {
  getUsersByUsername,
  postUserNewPassword,
} from "src/general_helpers/UsersData";

import useMediaQuery from "@mui/material/useMediaQuery";

let credencialesNew = require("../configs/credentials.json");

export const Login = () => {
  const { dispatch } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [modalState, setmodalState] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [idTokenCognito, setIdtoken] = useState("");
  const theme = useTheme();
  const background = theme.palette.background.login;
  const backgroundInputs = theme.palette.mode === "dark" ? "black" : "white";
  const colorInputs = theme.palette.mode === "dark" ? "white" : "black";
  // eslint-disable-next-line no-unused-vars
  const [usuarioFaltaAuth, setUsuarioFaltaAuth] = useState("");
  const [cognitoUser, setCognitoUser] = useState(null);
  const [isPasswordChangeModalOpen, setIsPasswordChangeModalOpen] =
    useState(false);


  const [encriptacion, setEncriptacion] = useState(
    localStorage.getItem("encriptacion") !== null
      ? localStorage.getItem("encriptacion") === "true"
      : true
  );
  const [loading, setLoading] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const handleCloseDialogNewPassword = () => {
    setIsPasswordChangeModalOpen(false);
  };

  // Función para buscar los parametros del proyecto
  function buscarPorIdProyecto(id) {
    return parametros_proyecto?.find((objeto) => objeto.id === id);
  }
  const proyecto_encontrado = buscarPorIdProyecto(id_proyecto);

  const imgUrl = proyecto_encontrado?.url_imagen;
  const usarVideo = proyecto_encontrado?.usar_video_login;
  const usarImagen = proyecto_encontrado?.usar_imagen_login;
  const usarCognito = proyecto_encontrado?.use_cognito;
  const [cognitoUse, setCognitoUse] = useState(
    localStorage.getItem("cognitoUse") !== null
      ? localStorage.getItem("cognitoUse") === "true"
      : usarCognito || false
  );
  // const aws_url_clave_firma = proyecto_encontrado?.aws_url_clave_firma;

  // ---------------------------------------------
  // GUARDAR PARAMETROS PROYECTO (EVITAR SET EN RENDER)

  localStorage.setItem(
    "parametros_proyecto",
    JSON.stringify(proyecto_encontrado)
  );


  const handleClickShowPassword = () => setShowPassword((show) => !show);

  // Datos del Form
  const [userInfo, setUserInfo] = useState({
    username: "",
    password: "",
    cliente: "",
  });

  const aws_id_cliente_aplicacion = userInfo?.cliente?.aws_id_cliente_aplicacion;
  const aws_id_grupo_user = userInfo?.cliente?.aws_id_grupo_user;

  const cleanDomain = (domain) =>
    typeof domain === "string" ? domain.replace(/\/+$/, "") : "";

  //NOTE FUNCION PARA CAMBIAR EL VALOR DEL LOCALSTORAGE DEL CLIENTE SELECCIONADO
  useEffect(() => {
    if (localStorage.getItem("clientData") !== null) {
      localStorage.setItem(
        "clientData",
        JSON.stringify({
          owner_code: userInfo?.cliente?.owner_code,
          api_pass: userInfo?.cliente?.api_pass,
          dominio: cleanDomain(userInfo?.cliente?.dominio),
          owner_descripcion: userInfo?.cliente?.descripcion,
          url_cognito: userInfo?.cliente?.url_cognito,
          aws_id_cliente_aplicacion: userInfo?.cliente?.aws_id_cliente_aplicacion,
          aws_id_grupo_user: userInfo?.cliente?.aws_id_grupo_user,
        })
      );
    }
  }, [userInfo]);

  const paramsGet = async (auth) => {
    function minutosAMilisegundos(minutos) {
      return minutos * 60000; // 1 minuto = 60 segundos = 60000 milisegundos
    }

    const response = await getParams();
    for (var i = 0; i < response.length; i++) {
      if (response[i].alias === "SESSION_TIME") {
        localStorage.setItem(
          "SESSION_TIME",
          JSON.stringify({
            time: minutosAMilisegundos(response[i].value),
          })
        );
      }
    }
    // eslint-disable-next-line no-unused-vars
    let data = await formatImagesParams(response);
  };

  const formatImagesParams = async (data) => {
    const parametrosImages = data.filter(
      (objeto) => objeto.group_field === "Images"
    );

    let parametrosImagenesFormateadas = new Map();

    for (const objeto of parametrosImages) {
      parametrosImagenesFormateadas.set(objeto.alias, objeto);
    }
    const objetoFormateado = Object.fromEntries(parametrosImagenesFormateadas);

    // Guardar en localStorage
    localStorage.setItem(
      "siam-params-images",
      JSON.stringify(objetoFormateado)
    );
  };

  const setHeader = async (e) => {
    //NOTE SETEO LOS VALORES DE OWNER CODE Y API PASS SELECCIONADOS EN UN LOCALSTORAGE PARA QUE EL HEADER PUEDA ACCEDER A ELLOS
    localStorage.setItem(
      "clientData",
      JSON.stringify({
        owner_code: userInfo?.cliente?.owner_code,
        api_pass: userInfo?.cliente?.api_pass,
        dominio: userInfo?.cliente?.dominio,
        owner_descripcion: userInfo?.cliente?.descripcion,
        url_cognito: userInfo?.cliente?.url_cognito,
        aws_id_cliente_aplicacion: userInfo?.cliente?.aws_id_cliente_aplicacion,
        aws_id_grupo_user: userInfo?.cliente?.aws_id_grupo_user,
      })
    );

    //NOTE SETEO LOS VALORES DE OWNER CODE SELECCIONADO EN EL CONFIG PARA QUE EL BODY PUEDA ACCEDER A ELLOS
    config.credentials.authorization.owner_code = userInfo?.cliente?.owner_code;
  };

  const handleConfirmationCodeEmail = (code) => {
    const poolData = {
      // UserPoolId: 'us-east-1_IicsmhSD0',
      // ClientId: '58lb2ugcj8ukmk2hl7q9sh4rbq'
      UserPoolId: aws_id_grupo_user,
      ClientId: aws_id_cliente_aplicacion,
    };

    const userPool = new CognitoUserPool(poolData);

    const userData = {
      Username: userInfo.username,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.confirmRegistration(code, true, (err, result) => {
      if (err) {
        console.error(err);

        setSeverity("error");
        setMessage("Error al validar el Usuario");
        setSnackbarVisible(true);
      } else {
        handleCloseDialog();
        handleLogin();
      }
    });
  };

  const handleSolicitNewCode = () => {
    const poolData = {
      // UserPoolId: 'us-east-1_IicsmhSD0',
      // ClientId: '58lb2ugcj8ukmk2hl7q9sh4rbq'
      UserPoolId: aws_id_grupo_user,
      ClientId: aws_id_cliente_aplicacion,
    };

    const userPool = new CognitoUserPool(poolData);

    // Crea una instancia de CognitoUser usando el nombre de usuario
    const username = userInfo.username;
    const userData = {
      Username: username,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.resendConfirmationCode((err, result) => {
      if (err) {
        console.error(err);
        setSeverity("error");
        setMessage("Error al enviar el codigo de confirmacion");
        setSnackbarVisible(true);
      } else {
        setSeverity("success");
        setMessage(
          "Nuevo código de confirmación enviado correctamente a  " +
          result.CodeDeliveryDetails.Destination
        );
        setSnackbarVisible(true);
      }
    });
  };

  ///Habilita o no el enciptado de datos
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.shiftKey && event.key === " ") {
        setEncriptacion((prevEncriptacion) => {
          if (prevEncriptacion) {
            localStorage.setItem("encriptacion", "false");
            setSeverity("warning");
            setMessage("Encriptado Deshabilitado");
            setSnackbarVisible(true);
            // encriptacion = false
            setEncriptacion(false);
          } else {
            localStorage.setItem("encriptacion", "true");
            setSeverity("success");
            setMessage("Encriptado Habilitado");
            setSnackbarVisible(true);
            // encriptacion = true
            setEncriptacion(true);
          }
          return !prevEncriptacion;
        });
      }

      if (event.shiftKey && event.key === "C") {
        setCognitoUse((prevCognitoUse) => {
          if (prevCognitoUse) {
            localStorage.setItem("cognitoUse", false);
            setSeverity("warning");
            setMessage("Uso de Cognito Deshabilitado");
            setSnackbarVisible(true);
          } else {
            localStorage.setItem("cognitoUse", true);
            setSeverity("success");
            setMessage("Uso de Cognito Habilitado");
            setSnackbarVisible(true);
          }
          return !prevCognitoUse;
        });
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    // localStorage.setItem("encriptacion", "true");
    // localStorage.setItem("cognitoUse", false);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const owner_code = userInfo?.cliente?.owner_code || "";
    localStorage.setItem(
      "owner_code",
      JSON.stringify({
        owner_code: owner_code,
      })
    );
    localStorage.setItem(
      "clientData",
      JSON.stringify({
        owner_code: userInfo?.cliente?.owner_code,
        api_pass: userInfo?.cliente?.api_pass,
        dominio: cleanDomain(userInfo?.cliente?.dominio),
        owner_descripcion: userInfo?.cliente?.descripcion,
        url_cognito: userInfo?.cliente?.url_cognito,
        aws_id_cliente_aplicacion: userInfo?.cliente?.aws_id_cliente_aplicacion,
        aws_id_grupo_user: userInfo?.cliente?.aws_id_grupo_user,
      })
    );
  }, [userInfo]);

  const handleNewPasswordSubmit = async (newPassword) => {
    console.log("Nuevo password recibido:", userInfo);
    const usuarioExists = await getUsersByUsername(userInfo.username);

    if (!usuarioExists) {
      setLoading(false);
      setSeverity("warning");
      setMessage("El usuario no está registrado");
      setSnackbarVisible(true);
      return;
    }
    const response = await postUserNewPassword(usuarioExists, newPassword);

    if (response) {
      setLoading(true);

      cognitoUser.completeNewPasswordChallenge(
        newPassword,
        {}, // ⬅️ SIEMPRE OBJETO VACÍO
        {
          onSuccess: async (session) => {
            const idToken = session.getIdToken().getJwtToken();
            const accessToken = session.getAccessToken().getJwtToken();

            const payload = JSON.parse(atob(idToken.split(".")[1]));
            console.log("payload", payload);
            const profile = payload["custom:profile"];

            localStorage.setItem("cognitoIdToken", idToken);
            localStorage.setItem("cognitoAccessToken", accessToken);
            localStorage.setItem("userProfile", profile);

            setIsPasswordChangeModalOpen(false);
            setLoading(false);

            // Login interno de tu sistema
            await loginSiam(newPassword);
          },

          onFailure: (err) => {
            console.error("❌ ERROR CAMBIANDO PASSWORD", err);
            setLoading(false);
            setSeverity("warning");
            setMessage(
              "Error al cambiar la contraseña. Verificá los requisitos."
            );
            setSnackbarVisible(true);
          },
        }
      );
    } else {
      setLoading(false);
      setSeverity("error");
      setMessage("Error al actualizar la contraseña en el sistema");
      setSnackbarVisible(true);
    }
  };

  // TODO:LOGIN USANDO COGNITO
  // eslint-disable-next-line
  const handleLogin = async () => {
    localStorage.setItem("cognitoUse", cognitoUse);
    if (!cognitoUse) {
      await loginSiam();
      return;
    }
    setLoading(true);
    const poolData = {
      UserPoolId: aws_id_grupo_user,
      ClientId: aws_id_cliente_aplicacion,
    };

    const userPool = new CognitoUserPool(poolData);

    const authenticationDetails = new AuthenticationDetails({
      Username: userInfo.username,
      Password: userInfo.password, // ✅ SIN encode
    });

    const cognitoUser = new CognitoUser({
      Username: userInfo.username,
      Pool: userPool,
    });

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: async (session) => {
        const idToken = session.getIdToken().getJwtToken();
        const accessToken = session.getAccessToken().getJwtToken();

        // Leer perfil desde el token
        const payload = JSON.parse(atob(idToken.split(".")[1]));
        const profile = payload["custom:profile"];

        // Guardar tokens
        localStorage.setItem("cognitoIdToken", idToken);
        localStorage.setItem("cognitoAccessToken", accessToken);
        localStorage.setItem("userProfile", profile);
        setLoading(false);

        // Login SIAM (si corresponde)
        await loginSiam();

        // Redirección o estado
        setIdtoken(idToken);
      },

      newPasswordRequired: (userAttributes) => {
        setLoading(false);
        // Guardar el usuario para completar el challenge
        setCognitoUser(cognitoUser);
        setIsPasswordChangeModalOpen(true);
      },

      onFailure: (err) => {
        setLoading(false);
        console.error("❌ LOGIN ERROR", err);
        if (err.code === "UserNotConfirmedException") {
          setSeverity("warning");
          setMessage("El usuario debe confirmar su mail");
          setSnackbarVisible(true);
          setUsuarioFaltaAuth(true);
          handleOpenDialog();
        } else if (err.code === "NewPasswordRequiredException") {
          setCognitoUser(cognitoUser);
          setIsPasswordChangeModalOpen(true);
        } else {
          setSeverity("warning");
          setMessage("El usuario o la contraseña es incorrecta");
          setSnackbarVisible(true);
        }
      },
    });
  };

  const loginSiam = async (newPassword = false) => {
    let userInfoService = { ...userInfo };
    if (
      userInfoService.username.length <= 0 ||
      userInfoService.password.length <= 0 ||
      userInfoService.cliente === ""
    ) {
      setSeverity("warning");
      setMessage("Tiene que completar todos los campos");
      setSnackbarVisible(true);
      return;
    }

    let response = { status: "false", cancel: true };

    //NOTE SETEO LOS VALORES DE OWNER CODE Y API PASS SELECCIONADOS EN UN LOCALSTORAGE PARA QUE EL HEADER PUEDA ACCEDER A ELLOS
    localStorage.setItem(
      "clientData",
      JSON.stringify({
        owner_code: userInfoService?.cliente?.owner_code,
        api_pass: userInfoService?.cliente?.api_pass,
        dominio: cleanDomain(userInfoService?.cliente?.dominio),
        owner_descripcion: userInfoService?.cliente?.descripcion,
        url_cognito: userInfoService?.cliente?.url_cognito,
        aws_id_cliente_aplicacion:
          userInfoService?.cliente?.aws_id_cliente_aplicacion,
        aws_id_grupo_user: userInfoService?.cliente?.aws_id_grupo_user,
      })
    );
    userInfoService.password = newPassword
      ? newPassword
      : userInfoService.password;

    //NOTE SETEO LOS VALORES DE OWNER CODE SELECCIONADO EN EL CONFIG PARA QUE EL BODY PUEDA ACCEDER A ELLOS
    config.credentials.authorization.owner_code =
      userInfoService?.cliente?.owner_code;

    if (userInfoService.username.length < 1) {
      Swal.fire({
        icon: "warning",
        title: "¡Atención!",
        text: "El campo usuario no puede estar vacio",
      });
    } else if (
      userInfoService.password.length < 1 ||
      /\s/.test(userInfoService.password)
    ) {
      var text = "El campo contraseña no puede estar vacio.";
      if (/\s/.test(userInfoService.password)) {
        text = "El campo contraseña no puede contener espacios en blanco.";
      }
      Swal.fire({
        icon: "warning",
        title: "¡Atención!",
        text: text,
      });
    } else if (userInfoService.cliente === "") {
      Swal.fire({
        icon: "warning",
        title: "¡Atención!",
        text: "Debe seleccionar un cliente",
      });
    } else {
      //NOTE LLAMO EL FETCH PARA LOGUEARME
      await paramsGet();

      response = await loginFetch(userInfoService);
    }

    if (response.status === "true") {
      sessionStorage.setItem("sessionLogin", true);
      dispatch({
        type: types.login,
        payload: {
          userInfo: userInfoService,
          username: userInfoService.username,
          token: encode(
            `${userInfoService.username}:${userInfoService.password}`
          ),
        },
      });
      config.authToken = encode(
        `${userInfoService.cliente.owner_code}:${userInfoService.cliente.api_pass}`
      );
      localStorage.setItem(
        "authToken",
        encode(
          `${userInfoService.cliente.owner_code}:${userInfoService.cliente.api_pass}`
        )
      );

      localStorage.setItem("passUser", userInfoService.password);
      // Después de iniciar sesión, establece una cookie de sesión
      Cookies.set("session", "loggedIn");
    } else {
      if (!response.cancel) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Algo salio mal - " + response.message,
        });
      }
    }
  };

  //NOTE SIRVE PARA QE SE ACTIVE LA FUNCION DE MOSTRAR CONTRASEÑA
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const toggleModal = () => {
    if (userInfo.cliente === "") {
      setSeverity("warning");
      setMessage("Tiene que seleccionar un cliente");
      setSnackbarVisible(true);
      return;
    }
    setmodalState(!modalState);
  };

  const dialogChild = (
    <RecuperarContrasenia
      setHeader={setHeader}
      // setButtonClicked={setButtonClicked}
      toggleModal={toggleModal}
      // setUserSelect={setUserSelect}
      setSnackbarVisible={setSnackbarVisible}
      setMessage={setMessage}
      setSeverity={setSeverity}
      aws_id_grupo_user={aws_id_grupo_user}
      aws_id_cliente_aplicacion={aws_id_cliente_aplicacion}
      setLoading={setLoading}
    />
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh", // Ajusta el alto para que toda la imagen sea visible
        backgroundImage: theme.backgroundImage.default, // Aquí utilizamos la imagen importada
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: isMobile ? "12px" : "0px",
      }}
    >
      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => {
          setSnackbarVisible(false);
        }}
      />

      <SimpleDialogComponent
        open={modalState}
        modalName={"Recuperar contraseña"}
        child={dialogChild}
        handleClose={toggleModal}
        buttonEnviar={false}
        buttonCancelar={false}
        maxWidth="sm"
      />

      <Container maxWidth="lg" sx={{ width: "100%" }}>
        <Box>
          <Grid container>
            <CssBaseline />

            {/* PANEL VIDEO / IMAGEN - SOLO DESKTOP */}
            {!isMobile && (
              <Grid
                item
                sm={4}
                md={7}
                component={Paper}
                elevation={6}
                square
                sx={{
                  backgroundColor: "#FFFFFF",
                  borderTopLeftRadius: "12px",
                  borderBottomLeftRadius: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {usarVideo ? (
                  <video
                    autoPlay
                    loop
                    muted
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  >
                    <source src={Video_Login} type="video/mp4" />
                    Tu navegador no admite el elemento de video.
                  </video>
                ) : null}

                {usarImagen ? (
                  <img
                    src={imgUrl}
                    alt="Descripción de la imagen"
                    style={{
                      position: "absolute",
                      maxWidth: "80%",
                      maxHeight: "80%",
                    }}
                  />
                ) : null}
              </Grid>
            )}

            {/* PANEL FORM */}
            <Grid
              item
              xs={12}
              sm={8}
              md={5}
              component={Paper}
              elevation={6}
              square
              sx={{
                background: background,
                borderRadius: isMobile ? "12px" : "0px",
                borderTopRightRadius: isMobile ? "12px" : "12px",
                borderBottomRightRadius: isMobile ? "12px" : "12px",
                borderTopLeftRadius: isMobile ? "12px" : "0px",
                borderBottomLeftRadius: isMobile ? "12px" : "0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                py: isMobile ? 4 : 0,
              }}
            >
              <Box
                sx={{
                  my: isMobile ? 2 : 8,
                  mx: isMobile ? 2 : 4,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",

                }}
              >
                <Grid
                  style={{
                    padding: isMobile ? "16px" : "30px",
                    margin: "auto",
                    display: "grid",
                    justifyItems: "center",
                    width: "100%",
                  }}
                >
                  <Typography
                    variant={isMobile ? "h2" : "h2"}
                    gutterBottom
                    style={{ color: "white" }}
                  >
                    Login
                  </Typography>

                  {/* CAMPO CLIENTE */}
                  <Box sx={{ display: "flex", alignItems: "flex-end", width: "100%", justifyContent: "center" }}>
                    <PersonSearchIcon
                      sx={{ fontSize: 40, color: "white", mr: 1, my: 0.5 }}
                    />
                    <FormControl
                      variant="filled"
                      sx={{ width: "100%", maxWidth: 420 }}
                    >
                      <InputLabel id="demo-simple-select-standard-label">
                        Cliente
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={userInfo.cliente}
                        onChange={(e) =>
                          setUserInfo({ ...userInfo, cliente: e.target.value })
                        }
                        label="Cliente"
                        variant="filled"
                        style={{
                          color: colorInputs,
                          backgroundColor: backgroundInputs,
                        }}
                      >
                        {credencialesNew && credencialesNew.length > 0 ? (
                          credencialesNew.map((owner) => (
                            <MenuItem
                              key={owner.owner_code}
                              value={owner}
                              style={{ display: "flex", textAlign: "left" }}
                            >
                              {owner.descripcion}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem
                            key={0}
                            value={0}
                            style={{ display: "flex" }}
                          >
                            {"No hay depositos disponibles"}
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Box>

                  <form autoComplete="off" style={{ width: "100%", display: "grid", justifyItems: "center" }}>
                    {/* CAMPO USUARIO */}
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        backgroundColor: "transparent",
                        width: "100%",
                        justifyContent: "center",
                      }}
                    >
                      <AccountCircle
                        sx={{ fontSize: 40, color: "white", mr: 1, my: 0.5 }}
                      />
                      <FormControl
                        sx={{ width: "100%", maxWidth: 420, marginTop: "2%" }}
                        variant="filled"
                      >
                        <InputLabel
                          htmlFor="filled-adornment-username"
                          sx={{
                            marginTop:
                              userInfo.username !== "" ? "-5px" : "auto",
                          }}
                        >
                          Usuario
                        </InputLabel>
                        <FilledInput
                          id="filled-adornment-username"
                          type="text"
                          autoComplete="off"
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              username: e.target.value,
                            })
                          }
                          style={{
                            color: colorInputs,
                            backgroundColor: backgroundInputs,
                            fontFamily: "Helvetica Neue, sans-serif",
                            fontSize: "16px",
                          }}
                        />
                      </FormControl>
                    </Grid>

                    {/* CAMPO PASSWORD */}
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        backgroundColor: "transparent",
                        width: "100%",
                        justifyContent: "center",
                      }}
                    >
                      <KeyIcon
                        sx={{ fontSize: 40, color: "white", mr: 1, my: 0.5 }}
                      />
                      <FormControl
                        sx={{ width: "100%", maxWidth: 420, marginTop: "2%" }}
                        variant="filled"
                      >
                        <InputLabel
                          htmlFor="filled-adornment-password"
                          sx={{
                            marginTop:
                              userInfo.password !== "" ? "-5px" : "auto",
                          }}
                        >
                          Password
                        </InputLabel>
                        <FilledInput
                          id="filled-adornment-password"
                          type={showPassword ? "text" : "password"}
                          autoComplete="new-password" // Use new-password for password fields
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              password: e.target.value,
                            })
                          }
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleLogin(e)
                          }
                          style={{
                            color: colorInputs,
                            backgroundColor: backgroundInputs,
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>
                  </form>

                  <Box
                    sx={{
                      width: "100%",
                      pt: 4,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >

                    <Button
                      fullWidth={isMobile}
                      size="small"
                      style={{ textAlign: "left", color: "white", justifyContent: "flex-start" }}
                      onClick={toggleModal}
                    >
                      Olvidaste tu contraseña?
                    </Button>


                    <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                      <Button
                        size="large"
                        variant="outlined"
                        sx={{
                          color: "white",
                          border: "2px solid white",
                          width: isMobile ? "140px" : "auto",
                          "&:hover": {
                            border: "2px solid black",
                            background: "white",
                            color: "black",
                          },
                        }}
                        onClick={handleLogin}
                        endIcon={<LoginIcon />}
                      >
                        Iniciar
                      </Button>
                    </Box>
                  </Box>


                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <LoadingOverlay open={loading} />

      <ConfirmationModal
        modalName="Confirmar Email"
        open={isDialogOpen}
        isMobileDevice={isMobile}
        setPushData={handleConfirmationCodeEmail} // Función que manejará la acción de guardar
        setSolicitNewCode={handleSolicitNewCode}
        handleClose={handleCloseDialog}
        buttonEnviar={true} // Puedes ajustar según tus necesidades
        fullWidth={true} // Puedes ajustar según tus necesidades
        buttonNuevoCodigo={true}
        maxWidth="md" // Puedes ajustar según tus necesidades
      />

      <ConfirmationModal
        modalName="Cambio de contraseña por primer inicio"
        open={isPasswordChangeModalOpen}
        isMobileDevice={isMobile}
        setPushData={handleNewPasswordSubmit} // Función que manejará la acción de guardar
        // setSolicitNewCode={handleSolicitNewCode}
        handleClose={handleCloseDialogNewPassword}
        buttonEnviar={true} // Puedes ajustar según tus necesidades
        fullWidth={true} // Puedes ajustar según tus necesidades
        buttonNuevoCodigo={false}
        maxWidth="md" // Puedes ajustar según tus necesidades
      />

      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        hide={8000}
        close={() => {
          setSnackbarVisible(false);
        }}
      />
    </div>
  );
};
